import { getAvatarId } from "../utils/jwt";
import { GameParams } from "../validation/game-params";

const doMatch = (
    targeting: string[],
    value?: string | number | null | boolean | Record<string, unknown>,
): boolean => {
    const hasTargeting = targeting.length > 0;

    // The entry in question has targeting enabled for this field but none is available from the game-side -> hide the entry
    if (!value && hasTargeting) {
        return false;
    }

    // The value is totally missing -> show the entry
    if (!value) {
        return true;
    }

    // No targeting  is set -> show the entry
    if (!hasTargeting) {
        return true;
    }

    const asString = value.toString();

    return targeting.includes(asString);
};

const doMatchBoolean = (
    targeting: boolean,
    value?: string | number | null | boolean | Record<string, unknown>,
): boolean => {
    if (targeting && value) {
        return false;
    }

    return true;
};

export const filterEntry = (
    entry: InboxEvent | InboxArticle | InboxFullscreenEntry,
    gameParams: GameParams &
        Record<
            string,
            | string
            | number
            | boolean
            | undefined
            | null
            | Record<string, unknown>
        >,
) => {
    if (!entry.targeting) {
        return true;
    }

    const { country, platform, th, th2, jwt, youngPlayer } = gameParams;

    let {
        country: entryCountry,
        platform: entryPlatform,
        townHallLevel: entryTownHallLevel,
        builderHallLevel: entryBuilderHallLevel,
        avatarIds: entryAvatarIds,
        hideFromYoungPlayer: entryHideFromYoungPlayer,
    } = entry.targeting;

    entryCountry = entryCountry || [];
    entryPlatform = entryPlatform || [];
    entryTownHallLevel = entryTownHallLevel || [];
    entryBuilderHallLevel = entryBuilderHallLevel || [];
    entryAvatarIds = entryAvatarIds || [];
    entryHideFromYoungPlayer = entryHideFromYoungPlayer || false;

    const countryMatch = doMatch(entryCountry, country);
    const platformMatch = doMatch(entryPlatform, platform);
    const townHallMatch = doMatch(entryTownHallLevel, th);
    const builderHallMatch = doMatch(entryBuilderHallLevel, th2);
    const avatarIdsMatch = doMatch(entryAvatarIds, getAvatarId(jwt ?? ""));
    const hideFromYoungPlayerMatch = doMatchBoolean(
        entryHideFromYoungPlayer,
        youngPlayer,
    );

    return (
        countryMatch &&
        platformMatch &&
        townHallMatch &&
        builderHallMatch &&
        avatarIdsMatch &&
        hideFromYoungPlayerMatch
    );
};
